/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-control-static[_ngcontent-%COMP%]{text-indent:1em}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/planting-instructions/planting-instructions-form/planting-instructions-form.component.css.shim.ngstyle.js.pre-build-optimizer.js